module.exports = __webpack_public_path__ + "static/media/discountBanner.484834e5.jpg";